import { AppContext, AppSettings } from '@/contexts/app/helpers';
import { useContext } from 'react';

const useApp = () => useContext<AppSettings>(AppContext);

export default useApp;
